// @cs2ts-begin-auto-generated - do not modify
export const UserTaskNames = {
  'measure': 'measure',
  'analyze': 'analyze',
  'organizationitem': 'organizationitem',
  'plan': 'plan',
  'entityplan': 'entityplan',
  'compensate': 'compensate',
  'report': 'report',
  'orgentity': 'orgentity',
  'orguser': 'orguser',
  'organization': 'organization',
  'export': 'export',
  'global': 'global',
  'emissionfactor': 'emissionfactor',
  'organizationAdmin': 'organizationAdmin',
  'pricingPlan': 'pricingPlan',
}
// @cs2ts-end-auto-generated - do not modify